var map = {
	"./1.jpg": 2234,
	"./10.jpg": 2235,
	"./2.jpg": 2236,
	"./3.jpg": 2237,
	"./4.jpg": 2238,
	"./5.jpg": 2239,
	"./6.jpg": 2240,
	"./7.jpg": 2241,
	"./8.jpg": 2242,
	"./9.jpg": 2243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2233;